import { render, staticRenderFns } from "./ChatFlowsList.vue?vue&type=template&id=9e5d4e62&"
import script from "./ChatFlowsList.vue?vue&type=script&lang=js&"
export * from "./ChatFlowsList.vue?vue&type=script&lang=js&"
import style0 from "./ChatFlowsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports